module.exports = __webpack_public_path__ + "static/media/04_plantilla_combo_rectangular_marco_comida_6.495e1e37.png";